/* KMNCE main · PDP enhancements
   - Real Shopify variant selection (one-option products)
   - Variant image swap into [data-pdp-hero]
   - Cart-add via /cart/add.js + Section Rendering API → re-renders cart drawer
*/
(function () {
  'use strict';

  /* Variant picker + qty stepper live in main.js. This file owns
     only the cart-add fetch flow + drawer refresh. */
  document.querySelectorAll('[data-product]').forEach(function (root) {
    var form = root.querySelector('[data-pdp-form]');
    if (!form) return;
    var submit = root.querySelector('[data-pdp-submit]');

    /* ---------- Add to cart via fetch ---------- */
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (submit) { submit.disabled = true; submit.dataset.originalText = submit.innerHTML; submit.textContent = 'ADDING…'; }

      var fd = new FormData(form);
      fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
        method: 'POST',
        body: fd,
        credentials: 'same-origin',
        headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/javascript' }
      })
      .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
      .then(function () { return refreshCartDrawer(); })
      .then(function () { openCartDrawer(); })
      .catch(function () { /* swallow — fall back to redirect */ window.location = '/cart'; })
      .finally(function () {
        if (submit) {
          submit.disabled = false;
          if (submit.dataset.originalText) submit.innerHTML = submit.dataset.originalText;
        }
      });
    });
  });

  /* ---------- Cart drawer refresh via Section Rendering API ---------- */
  function refreshCartDrawer() {
    return fetch('/?sections=main-cart-drawer', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = data && data['main-cart-drawer'];
        if (!html) return;

        // Parse response and find the fresh <aside id="CartDrawer">.
        // The Section Rendering API wraps the section in
        // <div id="shopify-section-..." class="shopify-section">…</div>
        // — extract just the inner <aside> so we don't double-wrap.
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var freshDrawer = tmp.querySelector('#CartDrawer');
        if (!freshDrawer) return;

        var existing = document.getElementById('CartDrawer');
        if (!existing) return;

        // Preserve the open/closed state across refreshes.
        var wasOpen = existing.getAttribute('aria-hidden') === 'false';

        // Replace inner DOM only (keep the outer <aside id="CartDrawer">
        // node identity so listeners attached to the document still work
        // and CSS transitions don't re-trigger).
        existing.innerHTML = freshDrawer.innerHTML;
        if (wasOpen) {
          existing.setAttribute('aria-hidden', 'false');
        }

        // Update header cart count from cart.js
        return fetch('/cart.js', { credentials: 'same-origin' })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            document.querySelectorAll('.nav__cart-count').forEach(function (el) {
              el.textContent = cart.item_count;
            });
            restoreShippingEstimate();
          });
      });
  }

  function openCartDrawer() {
    var d = document.getElementById('CartDrawer');
    if (!d) return;
    d.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }

  function closeCartDrawer() {
    var d = document.getElementById('CartDrawer');
    if (!d) return;
    d.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  /* ---------- Header cart-icon click → open drawer ---------- */
  document.addEventListener('click', function (e) {
    var openBtn = e.target.closest('[data-open-cart]');
    if (openBtn) { e.preventDefault(); openCartDrawer(); return; }
    var checkoutBtn = e.target.closest('.cart-drawer__checkout');
    if (checkoutBtn) {
      // Force navigation — immune to any other handler's preventDefault.
      e.preventDefault();
      window.location.href = checkoutBtn.getAttribute('href') || '/checkout';
      return;
    }
    var closeBtn = e.target.closest('.cart-drawer__close, .cart-drawer__scrim');
    if (closeBtn) {
      closeCartDrawer();
      return;
    }
    /* ---------- Remove line item without leaving the page ---------- */
    var removeBtn = e.target.closest('.cart-line__remove');
    if (removeBtn) {
      e.preventDefault();
      removeCartItem(removeBtn);
      return;
    }
    /* ---------- Quantity stepper ---------- */
    var qtyBtn = e.target.closest('[data-cart-qty]');
    if (qtyBtn) {
      e.preventDefault();
      changeCartQty(qtyBtn);
      return;
    }
    /* ---------- Shipping estimator calculate button ---------- */
    var calcBtn = e.target.closest('.cart-drawer__shipping-btn');
    if (calcBtn) { runShippingEstimate(calcBtn); return; }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeCartDrawer();
  });

  /* ---------- Remove item via AJAX (drawer stays open) ---------- */
  function removeCartItem(link) {
    // href looks like /cart/change?id=<line-key>&quantity=0
    var href = link.getAttribute('href') || '';
    var match = href.match(/[?&]id=([^&]+)/);
    if (!match) { window.location.href = href; return; }
    var lineKey = decodeURIComponent(match[1]);
    link.textContent = 'Removing\u2026';
    fetch('/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: lineKey, quantity: 0 })
    })
    .then(function (r) {
      if (!r.ok) throw new Error('change failed');
      return refreshCartDrawer();
    })
    .catch(function () {
      // Fall back to the standard navigation behavior
      window.location.href = href;
    });
  }

  /* ---------- Quantity +/- via AJAX (drawer stays open) ---------- */
  function changeCartQty(btn) {
    var line = btn.closest('[data-line-key]');
    if (!line || line.hasAttribute('data-updating')) return;

    var valueEl = line.querySelector('[data-cart-qty-value]');
    var current = parseInt(valueEl && valueEl.textContent, 10) || 0;
    var next = btn.getAttribute('data-cart-qty') === '+' ? current + 1 : current - 1;
    if (next < 0) return;

    var lineKey = line.getAttribute('data-line-key');
    line.setAttribute('data-updating', '');

    fetch('/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: lineKey, quantity: next })
    })
    .then(function (r) {
      return r.json()
        .catch(function () { return null; })
        .then(function (body) { return { ok: r.ok, body: body }; });
    })
    .then(function (res) {
      // Refresh either way: on rejection the server state is the truth.
      return refreshCartDrawer().then(function () {
        if (res.ok) return;
        showQtyError(lineKey, (res.body && res.body.description) || 'Could not update quantity.');
      });
    })
    .catch(function () { window.location.href = '/cart'; });
  }

  function showQtyError(lineKey, message) {
    var line = document.querySelector('[data-line-key="' + lineKey + '"]');
    var note = line && line.querySelector('[data-cart-qty-error]');
    if (!note) return;
    note.textContent = message;
    note.hidden = false;
  }

  /* ---------- Shipping estimator (US zip only) ----------
     Shopify's rates API requires a state for US addresses, so we
     derive it from the zip. Specific/exception ranges listed first. */
  var US_ZIP_STATES = [
    [6390, 6390, 'New York'], [39901, 39901, 'Georgia'], [73301, 73301, 'Texas'],
    [83414, 83414, 'Wyoming'], [5501, 5544, 'Massachusetts'], [88510, 88589, 'Texas'],
    [20101, 20199, 'Virginia'],
    [1001, 2791, 'Massachusetts'], [2801, 2940, 'Rhode Island'], [3031, 3897, 'New Hampshire'],
    [3901, 4992, 'Maine'], [5001, 5907, 'Vermont'], [6001, 6928, 'Connecticut'],
    [7001, 8989, 'New Jersey'], [10001, 14975, 'New York'], [15001, 19640, 'Pennsylvania'],
    [19701, 19980, 'Delaware'], [20001, 20599, 'District of Columbia'], [20601, 21930, 'Maryland'],
    [22001, 24658, 'Virginia'], [24701, 26886, 'West Virginia'], [27006, 28909, 'North Carolina'],
    [29001, 29948, 'South Carolina'], [30001, 31999, 'Georgia'], [32004, 34997, 'Florida'],
    [35004, 36925, 'Alabama'], [37010, 38589, 'Tennessee'], [38601, 39776, 'Mississippi'],
    [40003, 42788, 'Kentucky'], [43001, 45999, 'Ohio'], [46001, 47997, 'Indiana'],
    [48001, 49971, 'Michigan'], [50001, 52809, 'Iowa'], [53001, 54990, 'Wisconsin'],
    [55001, 56763, 'Minnesota'], [57001, 57799, 'South Dakota'], [58001, 58856, 'North Dakota'],
    [59001, 59937, 'Montana'], [60001, 62999, 'Illinois'], [63001, 65899, 'Missouri'],
    [66002, 67954, 'Kansas'], [68001, 69367, 'Nebraska'], [70001, 71497, 'Louisiana'],
    [71601, 72959, 'Arkansas'], [73001, 74966, 'Oklahoma'], [75001, 79999, 'Texas'],
    [80001, 81658, 'Colorado'], [82001, 83128, 'Wyoming'], [83201, 83876, 'Idaho'],
    [84001, 84784, 'Utah'], [85001, 86556, 'Arizona'], [87001, 88441, 'New Mexico'],
    [88901, 89883, 'Nevada'], [90001, 96162, 'California'], [96701, 96898, 'Hawaii'],
    [97001, 97920, 'Oregon'], [98001, 99403, 'Washington'], [99501, 99950, 'Alaska']
  ];

  function zipToState(zip5) {
    var n = parseInt(zip5, 10);
    if (isNaN(n)) return null;
    for (var i = 0; i < US_ZIP_STATES.length; i++) {
      if (n >= US_ZIP_STATES[i][0] && n <= US_ZIP_STATES[i][1]) return US_ZIP_STATES[i][2];
    }
    return null;
  }

  /* ---------- Estimated total (subtotal + chosen shipping rate) ----------
     Persisted in sessionStorage so the estimate survives the drawer
     re-render that every cart mutation triggers. */
  var SHIPPING_KEY = 'kmnce:shipping-estimate';
  var lastShippingRates = [];

  function loadShippingState() {
    try { return JSON.parse(sessionStorage.getItem(SHIPPING_KEY)); } catch (e) { return null; }
  }

  function saveShippingState(state) {
    try {
      if (state) sessionStorage.setItem(SHIPPING_KEY, JSON.stringify(state));
      else sessionStorage.removeItem(SHIPPING_KEY);
    } catch (e) { /* private mode — estimate just won't persist */ }
  }

  function formatMoney(cents, currency) {
    try {
      return new Intl.NumberFormat(undefined, {
        style: 'currency', currency: currency || 'USD'
      }).format(cents / 100);
    } catch (e) {
      return '$' + (cents / 100).toFixed(2);
    }
  }

  function escapeHtml(str) {
    return String(str).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function rateName(rate) { return rate.presentment_name || rate.name || 'Shipping'; }

  function renderTotals() {
    var totals = document.querySelector('.cart-drawer__totals');
    if (!totals) return;
    var shipRow = totals.querySelector('[data-shipping-line]');
    var totalRow = totals.querySelector('[data-estimated-total-row]');
    if (!shipRow || !totalRow) return;

    var saved = loadShippingState();
    if (!saved || !saved.rate) {
      shipRow.hidden = true;
      totalRow.hidden = true;
      return;
    }

    var cartTotal = parseInt(totals.getAttribute('data-cart-total'), 10) || 0;
    var currency = totals.getAttribute('data-currency') || 'USD';
    var shipCents = Math.round(parseFloat(saved.rate.price) * 100) || 0;

    totals.querySelector('[data-shipping-label]').textContent = 'Shipping (' + saved.rate.name + ')';
    totals.querySelector('[data-shipping-amount]').textContent =
      shipCents === 0 ? 'Free' : formatMoney(shipCents, currency);
    totals.querySelector('[data-estimated-total]').textContent = formatMoney(cartTotal + shipCents, currency);
    shipRow.hidden = false;
    totalRow.hidden = false;
  }

  function clearShippingEstimate() {
    lastShippingRates = [];
    saveShippingState(null);
    renderTotals();
  }

  // Re-run after a drawer refresh: rates depend on cart weight, so a stale
  // number would be worse than none.
  function restoreShippingEstimate() {
    var saved = loadShippingState();
    var zipInput = document.getElementById('ShippingCalcZip');
    renderTotals();
    if (!saved || !saved.zip || !zipInput) return;
    zipInput.value = saved.zip;

    var totals = document.querySelector('.cart-drawer__totals');
    var current = totals ? parseInt(totals.getAttribute('data-cart-total'), 10) : null;
    if (saved.total === current) return;
    runShippingEstimate(null);
  }

  document.addEventListener('change', function (e) {
    var radio = e.target.closest && e.target.closest('input[name="cart-shipping-rate"]');
    if (!radio) return;
    var rate = lastShippingRates[parseInt(radio.value, 10)];
    var saved = loadShippingState();
    if (!rate || !saved) return;
    saved.rate = { name: rateName(rate), price: rate.price };
    saveShippingState(saved);
    renderTotals();
  });

  function runShippingEstimate(btn) {
    var zipInput = document.getElementById('ShippingCalcZip');
    var results = document.querySelector('.cart-drawer__shipping-results');
    if (!zipInput || !results) return;
    var zipVal = zipInput.value.replace(/[^0-9]/g, '').slice(0, 5);
    if (zipVal.length !== 5) {
      results.innerHTML = '<p class="cart-drawer__shipping-msg">Enter a valid 5-digit US zip code.</p>';
      clearShippingEstimate();
      return;
    }
    var state = zipToState(zipVal);
    if (!state) {
      results.innerHTML = '<p class="cart-drawer__shipping-msg">Enter a valid US zip code.</p>';
      clearShippingEstimate();
      return;
    }
    var origLabel = btn ? btn.textContent : '';
    if (btn) {
      btn.disabled = true;
      btn.textContent = 'Calculating\u2026';
    }
    fetch('/cart/shipping_rates.json', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({
        shipping_address: { zip: zipVal, country: 'United States', province: state }
      })
    })
    .then(function (r) { return r.json(); })
    .then(function (data) {
      if (data.shipping_rates && data.shipping_rates.length > 0) {
        lastShippingRates = data.shipping_rates;

        // Keep the customer's previous pick if it's still offered, else cheapest.
        var saved = loadShippingState();
        var previous = saved && saved.rate ? saved.rate.name : null;
        var selected = 0;
        data.shipping_rates.forEach(function (rate, i) {
          if (parseFloat(rate.price) < parseFloat(data.shipping_rates[selected].price)) selected = i;
        });
        data.shipping_rates.forEach(function (rate, i) {
          if (previous && rateName(rate) === previous) selected = i;
        });

        var totalsEl = document.querySelector('.cart-drawer__totals');
        var currency = data.shipping_rates[selected].currency ||
          (totalsEl && totalsEl.getAttribute('data-currency')) || 'USD';

        results.innerHTML = data.shipping_rates.map(function (rate, i) {
          var cents = Math.round(parseFloat(rate.price) * 100) || 0;
          return '<label class="cart-drawer__shipping-rate">' +
            '<input type="radio" name="cart-shipping-rate" value="' + i + '"' +
              (i === selected ? ' checked' : '') + '>' +
            '<span class="cart-drawer__shipping-rate-name">' + escapeHtml(rateName(rate)) + '</span>' +
            '<span class="cart-drawer__shipping-rate-price">' +
              (cents === 0 ? 'Free' : formatMoney(cents, currency)) +
            '</span>' +
          '</label>';
        }).join('');

        saveShippingState({
          zip: zipVal,
          total: parseInt(totalsEl && totalsEl.getAttribute('data-cart-total'), 10) || 0,
          rate: { name: rateName(data.shipping_rates[selected]), price: data.shipping_rates[selected].price }
        });
        renderTotals();
      } else if (data && !data.shipping_rates) {
        // Surface API validation messages (e.g. "zip is not valid")
        var msgs = Object.keys(data).map(function (k) {
          var v = data[k];
          return Array.isArray(v) ? k + ' ' + v.join(', ') : String(v);
        });
        results.innerHTML = '<p class="cart-drawer__shipping-msg">' + escapeHtml(msgs.join('; ') || 'No shipping rates found for this zip code.') + '</p>';
        clearShippingEstimate();
      } else {
        results.innerHTML = '<p class="cart-drawer__shipping-msg">No shipping rates found for this zip code.</p>';
        clearShippingEstimate();
      }
    })
    .catch(function () {
      results.innerHTML = '<p class="cart-drawer__shipping-msg">Unable to calculate shipping. Please try again.</p>';
    })
    .finally(function () {
      if (btn) {
        btn.disabled = false;
        btn.textContent = origLabel;
      }
    });
  }

  /* ---------- Sync cart on page restore (bfcache + tab focus) ----------
     Browsers often restore the page from bfcache when the user clicks
     "Back" from Shopify checkout. The Liquid-rendered cart count then
     reflects the pre-checkout state — even after the order completes.
     Re-fetch /cart.js whenever the page becomes visible again so the
     count and drawer reflect the real cart.
  --------------------------------------------------------------------- */
  function syncCartFromServer() {
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('.nav__cart-count').forEach(function (el) {
          el.textContent = cart.item_count;
        });
        // Refresh drawer markup if the page exposes it
        if (document.getElementById('CartDrawer')) refreshCartDrawer();
      })
      .catch(function () { /* offline — leave UI as-is */ });
  }
  window.addEventListener('pageshow', function (e) {
    // event.persisted === true means restored from bfcache.
    // On normal loads we still re-sync once so the drawer reflects the
    // real /cart.js state (avoids stale Liquid render after a navigation
    // that raced with a cart cookie set).
    syncCartFromServer();
  });
  // Sync when the tab regains focus AFTER having been hidden (not on
  // initial page load). Guards against the cart count being stale after
  // a checkout completes in another tab/window.
  var wasHidden = false;
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'hidden') { wasHidden = true; return; }
    if (document.visibilityState === 'visible' && wasHidden) {
      wasHidden = false;
      syncCartFromServer();
    }
  });
})();
